module.exports = __webpack_public_path__ + "img/icon_xls.14488496.jpg";